import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'; 

document.addEventListener('DOMContentLoaded', () => {
    $('.select2-enable').select2({dropdownCssClass: "select2-custom-dropdown"});
});
